import React from 'react';
import { buildApexBoxingPlan } from '../../utils/apexBoxing';

const PackingContext = React.createContext(null);

export default function PackingGuidance({ clientId, orderId, items, children }) {
  if (Number(clientId) !== 2) return <PackingContext.Provider value={{ status: 'not-applicable' }}>{children}</PackingContext.Provider>;
  return <ApexPackingGuidance key={String(orderId)} orderId={orderId} items={items}>{children}</ApexPackingGuidance>;
}

function ApexPackingGuidance({ orderId, items, children }) {
  const currentItems = items.every(item => String(item.or_id) === String(orderId)) ? items : [];
  const snapshot = JSON.stringify(currentItems.map(item => ({
    cl_id: item.cl_id,
    oi_id: item.oi_id,
    pr_sku: item.pr_sku,
    apex_oversize: item.apex_oversize,
    oi_qty: item.oi_qty
  })).sort((a, b) => String(a.oi_id).localeCompare(String(b.oi_id))));
  const plan = React.useMemo(() => buildApexBoxingPlan(2, JSON.parse(snapshot)), [snapshot]);
  return (
    <PackingContext.Provider value={plan}>
      {children}
    </PackingContext.Provider>
  );
}

export function PackingInstructions({ item }) {
  return (
    <PackingContext.Consumer>
      {plan => {
        const itemPlan = plan || buildApexBoxingPlan(item.cl_id, [item]);
        if (itemPlan.status !== 'ready' ||
            !itemPlan.singleBoxItemIds.includes(String(item.oi_id))) return null;
        return (
          <div className="packing-instructions" role="alert"
            style={{ marginTop: 2, color: '#007bff', fontSize: 12, fontWeight: 600, lineHeight: 1.3, whiteSpace: 'normal', overflowWrap: 'break-word' }}>
            Pack each unit in its own box.
          </div>
        );
      }}
    </PackingContext.Consumer>
  );
}

export function PackingSku({ item, sku }) {
  return (
    <div style={{ textAlign: 'center' }}>
      <div>{sku}</div>
      <PackingInstructions item={item} />
    </div>
  );
}
